import {
  Box,
  Button,
  CircularProgress,
  Container,
  TextField,
  Typography,
} from "@mui/material";

import { useFormik} from "formik";
import * as Yup from "yup";
import { setCookie } from "cookies-next";
import { LoginCommand, UserItem } from "../api/models/schema";
import { useContext, useEffect, useState } from "react";
import { useApi } from "../hooks/useApi";
import { loginApi } from "../api/liveMarketingApi";
import { useNavigate } from 'react-router-dom';
import dayjs from "dayjs";
import { AppUserContext } from "../context/appUserContext";

export function LoginPage(){

    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    const loginRequest = useApi(loginApi);
    const navigate = useNavigate();

    const { appUser, refreshUser } = useContext(AppUserContext);

    useEffect(() => {
        if (loginRequest.error) {
          setHasError(true);
          setIsLoading(false);
        }
      }, [loginRequest.error]);

      useEffect(() => {
        if (loginRequest.data) {

            const currentUser = loginRequest.data as UserItem;
            addCookie(currentUser);
            refreshUser();

            if(currentUser.permissions.length > 1){
                navigate(`/organizations`);
            }
            else if (currentUser.permissions.length === 1){
                navigate(`/dashboard/${currentUser.permissions[0].organizationId}`);
            }
            else
            {
                //todo: need to set an error for the page
                setHasError(true);
            }


            setIsLoading(false);
        }
      }, [loginRequest.data]);


    const loginSchema = Yup.object().shape({
        userName: Yup.string().required("Required"),
        password: Yup.string().required("Required"),
      });

      function handleLogin(login: LoginCommand){

        setIsLoading(true);

        const logInCommand:LoginCommand = {
            userName: login.userName,
            password: login.password,
        };

        loginRequest.request(logInCommand);

      };

      function addCookie(userData: UserItem) {

        const userString = JSON.stringify(userData);

        const option = {
            path: "/",
            expires: dayjs().add(5, 'day').toDate(),
          };
          setCookie("userData", userString, option);
      }


    const formik = useFormik({
        initialValues: {
          userName: "",
          password: "",
        },
        validationSchema: loginSchema,
        onSubmit: async (values) => {
          await handleLogin(values);
        },
      });

     return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
       <Box  sx={{width:'100px'}} component='img' src='/images/lmIcon200.png' alt='' />
       <br/>
       <Box  sx={{width:'200px'}} component='img' src='/images/logo_2.png' alt='' />

        <Typography component="h1" variant="h5">
          Sign in
        </Typography>

        <Box sx={{ mt: 1 }}>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="userName"
              label="Email Address"
              name="userName"
              autoComplete="userName"
              autoFocus
              value={formik.values.userName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.userName && Boolean(formik.errors.userName)}
              helperText={formik.touched.userName && formik.errors.userName}
              style={{width: '100%'}}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              style={{width: '100%'}}
            />

            {hasError && (
              <Box sx={{ color: "#ff2222" }}>Error attempting to login</Box>
            )}
            <Button
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                display: "flex",
                justifyItems: "center",
                alignItems: "center",
                gap: "4",
              }}
              type="submit"
              disabled={isLoading}
            >
              Sign In
              {isLoading && <CircularProgress size={20} />}
            </Button>
          </form>
        </Box>
      </Box>
    </Container>
  );
}